import { useEffect, useState } from "react";
import { getSlots } from "@/lib/apiClient";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

// Shows only truly free slots of an advisor (computed server-side in Europe/Amsterdam).
export function SlotPicker({ advisorId, value, onPick, excludeId }) {
  const [from, setFrom] = useState(() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; });
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!advisorId) return;
    setData(null);
    getSlots(advisorId, ymd(from), 7, excludeId).then(setData).catch(() => setData({ days: [], has_availability: false }));
  }, [advisorId, from, excludeId]);

  if (!advisorId) return <p className="text-xs text-[#5B6675]">Kies eerst een adviseur.</p>;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const total = data?.days?.reduce((n, d) => n + d.slots.length, 0) || 0;
  return (
    <div data-testid="slot-picker" className="space-y-2">
      <div className="flex items-center gap-2">
        <button data-testid="slots-prev" disabled={from <= today} onClick={() => setFrom(addDays(from, -7))} className="p-1.5 rounded-lg border border-[#E2E7EC] bg-white disabled:opacity-40"><ChevronLeft className="h-4 w-4" /></button>
        <span className="text-xs font-medium text-[#16202B] flex-1 text-center">{from.toLocaleDateString("nl-NL", { day: "numeric", month: "short" })} – {addDays(from, 6).toLocaleDateString("nl-NL", { day: "numeric", month: "short" })}</span>
        <button data-testid="slots-next" onClick={() => setFrom(addDays(from, 7))} className="p-1.5 rounded-lg border border-[#E2E7EC] bg-white"><ChevronRight className="h-4 w-4" /></button>
      </div>
      {!data ? <p className="text-xs text-[#5B6675] flex items-center gap-1.5"><Loader2 className="h-3.5 w-3.5 animate-spin" /> Tijdsloten laden…</p>
        : !data.has_availability ? <p data-testid="slots-no-availability" className="text-xs text-[#B0413E]">Deze adviseur heeft nog geen beschikbaarheid ingesteld.</p>
        : total === 0 && !data.days.some((d) => d.taken?.length) ? <p data-testid="slots-none" className="text-xs text-[#5B6675]">Geen vrije tijdsloten in deze week. Probeer de volgende week.</p>
        : (
          <div className="space-y-2 max-h-72 overflow-y-auto fe-scroll">
            {data.days.filter((d) => d.slots.length || d.taken?.length).map((d) => (
              <div key={d.date}>
                <p className="text-[11px] uppercase tracking-wide font-semibold text-[#5B6675] mb-1">{new Date(`${d.date}T12:00`).toLocaleDateString("nl-NL", { weekday: "long", day: "numeric", month: "short" })}</p>
                <div className="flex flex-wrap gap-1.5">
                  {[...d.slots.map((s) => [s, true]), ...(d.taken || []).map((s) => [s, false])].sort().map(([s, free]) => free ? (
                    <button key={s} data-testid={`slot-${s}`} onClick={() => onPick(s)}
                      className={`text-xs font-medium px-2.5 py-1.5 rounded-lg border transition-colors ${value === s ? "bg-[#001C51] text-white border-[#001C51]" : "bg-white border-[#E2E7EC] text-[#001C51] hover:border-[#16BFBF]"}`}>{s.slice(11)}</button>
                  ) : (
                    <span key={s} data-testid={`slot-taken-${s}`} title="Bezet of niet beschikbaar" className="text-xs px-2.5 py-1.5 rounded-lg border border-dashed border-[#E2E7EC] text-[#B4BCC7] line-through cursor-not-allowed">{s.slice(11)}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      {data && <p className="text-[11px] text-[#8994A3]">Doorgestreept = bezet of geblokkeerd · Duur {data.duration_min} min · buffer {data.buffer_minutes} min · tijdzone Europe/Amsterdam</p>}
    </div>
  );
}
